<template lang="pug">
component(
  :is="dialogName"
  v-if="dialogName"
  v-bind="dialogFinalProps"
  v-on="dialogEvents"
)
</template>

<script>
import { recurringJobsDialogEvents } from '~/utils/work_orders';
import WorkOrdersRescheduleJobsDialog from '../WorkOrdersRescheduleJobsDialog.vue';
import WorkOrdersEditRecurringJobDialog from '../WorkOrdersEditRecurringJobDialog.vue';
import WorkOrdersEditRecurringJobSettingsDialog from '../WorkOrdersEditRecurringJobSettingsDialog.vue';
import WorkOrdersConfirmDeleteRecurringJobsDialog from '../WorkOrdersConfirmDeleteRecurringJobsDialog.vue';
import WorkOrdersEditPastJobConfirmDialog from '../WorkOrdersEditPastJobConfirmDialog.vue';

const { EVENTS } = recurringJobsDialogEvents;

// Helper manager to deal with simple dialogs during
// the recurring jobs creation, update & delete lifecycles
// and their "confirmation" dialogs/components without
// cluttering the components templates.
//
// NOTE: This will only ever render 1 dialog at a time for now.
export default {
  name: 'RecurringJobsDialogManager',
  components: {
    // Explicitly add the components here so that we know exactly
    // what dialogs are we managing from here...
    WorkOrdersRescheduleJobsDialog,
    WorkOrdersEditRecurringJobDialog,
    WorkOrdersEditRecurringJobSettingsDialog,
    WorkOrdersConfirmDeleteRecurringJobsDialog,
    WorkOrdersEditPastJobConfirmDialog,
  },
  data: () => ({
    loading: false,
    dialogName: null,
    dialogProps: {},
    dialogConfirmCallback: null,
    dialogCancelCallback: null,
  }),
  computed: {
    dialogFinalProps() {
      return {
        ...this.dialogProps,
        loading: this.loading,
      };
    },
    dialogEvents() {
      return {
        close: this.onCloseDialog,
        cancel: this.onCancelDialog,
        confirm: this.onConfirmDialog,
      };
    },
  },
  mounted() {
    recurringJobsDialogEvents.on(EVENTS.OPEN, this.onOpenDialog);
    recurringJobsDialogEvents.on(EVENTS.CLOSE, this.onCloseDialog);
    recurringJobsDialogEvents.on(EVENTS.LOADING, this.onSetLoadingProp);
  },
  beforeUnmount() {
    recurringJobsDialogEvents.off(EVENTS.OPEN, this.onOpenDialog);
    recurringJobsDialogEvents.off(EVENTS.CLOSE, this.onCloseDialog);
    recurringJobsDialogEvents.off(EVENTS.LOADING, this.onSetLoadingProp);
  },
  methods: {
    onOpenDialog({ dialogName, dialogEvents, dialogProps = {} }) {
      this.dialogName = dialogName;
      this.dialogProps = dialogProps;
      if (dialogEvents) {
        if (typeof dialogEvents.confirm === 'function') {
          this.dialogConfirmCallback = dialogEvents.confirm;
        }

        if (typeof dialogEvents.cancel === 'function') {
          this.dialogCancelCallback = dialogEvents.cancel;
        }
      }

      this.$emit('open', { dialogName });
    },
    onCancelDialog() {
      if (this.dialogCancelCallback) {
        this.dialogCancelCallback();
      }
      this.onCloseDialog('cancel');
    },
    onCloseDialog(closeEvent = 'close') {
      const dialogName = this.dialogName;

      this.dialogProps = {};
      this.dialogName = null;
      this.dialogConfirmCallback = null;
      this.dialogCancelCallback = null;
      this.$emit(closeEvent, { dialogName });
      recurringJobsDialogEvents.closed(dialogName);
    },
    onConfirmDialog(event) {
      if (this.dialogConfirmCallback) {
        this.dialogConfirmCallback(event);
      }
      recurringJobsDialogEvents.confirm(this.dialogName);
      this.$emit('confirm', { dialogName: this.dialogName });
    },
    onSetLoadingProp(loading) {
      this.loading = loading;
    },
  },
};
</script>
